import glamorous from "glamorous"

const List = glamorous.ul({
  listStyleType: "disc",
  fontSize: "1.05rem",
  paddingBottom: 20,
})

export default List



// WEBPACK FOOTER //
// ./src/elements/List.js